import React, { Component } from 'react';
import ActionRouter from './Actions/ActionRouter';
import { BigButton2 } from '../../Controls/BigButton';
import HotelInterface from './HotelInterface';
import InitialLodgingChoice from '../../Choices/InitialLodgingChoice';
import InventorySelector from './InventorySelector';
import LodgingSelector from './LodgingSelector';

export class ManualPlayerControls extends Component {

    constructor(props) {
        super(props);
        this.state = { show: true };
    }

    componentDidMount() {
        window.addEventListener('show-manual-controls',
            this.showManualControls);
        window.addEventListener('hide-manual-controls',
            this.hideManualControls);
    }

    componentWillUnmount() {
        window.removeEventListener('show-manual-controls',
            this.show);
        window.removeEventListener('hide-manual-controls',
            this.hide);
    }

    showManualControls = () => {
        this.setState({show: true});
    }

    hideManualControls = () => {
        this.setState({show: false});
    }

    render() {
        return <div id={'manual-player-controls'}>
            {this.state.show && <>
                <LodgingSelector {...this.props}/>
                {this.props.isMyInitialLodgingTurn && (
                    <InitialLodgingChoice {...this.props}/>
                )}

                <ActionRouter {...this.props}/>

                <HotelInterface {...this.props} />
                <InventorySelector {...this.props}/>
                <BigButton2 {...this.props}/>
            </>}
        </div>
    }

}
